
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function MeslekEgitimiPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-indigo-600 to-indigo-800 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Meslek Eğitimi ve MYK Sertifikaları</h1>
            <p className="text-xl md:text-2xl mb-8 text-indigo-100">
              ASSA Akademi ile Mesleki Eğitimler ve MYK Onaylı Sertifika Programları
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-lg">
              <span className="bg-white/20 px-4 py-2 rounded-full">Adana Meslek Eğitimi</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Mersin MYK Eğitimi</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Hatay Sertifika Programları</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Osmaniye Mesleki Eğitim</span>
            </div>
          </div>
        </div>
      </section>

      {/* ASSA Akademi Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">ASSA Akademi</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Adana, Mersin, Hatay ve Osmaniye illerinde mesleki eğitim ve MYK onaylı sertifika programları konusunda 
              uzmanlaşmış ASSA Akademi, kariyer gelişimi için kapsamlı eğitim hizmetleri sunar.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/470bab49b870436a9bfe7073cf4ee3c2.jpg"
                alt="ASSA Akademi Meslek Eğitimi ve MYK"
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-indigo-600 rounded-lg flex items-center justify-center">
                  <i className="ri-award-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">MYK Onaylı Sertifikalar</h3>
                  <p className="text-gray-600">Mesleki Yeterlilik Kurumu tarafından onaylı resmi sertifikalar ve mesleki yeterlilik belgeleri</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-indigo-600 rounded-lg flex items-center justify-center">
                  <i className="ri-graduation-cap-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Mesleki Eğitim Programları</h3>
                  <p className="text-gray-600">Sektörel ihtiyaçlara yönelik kapsamlı mesleki eğitim ve beceri geliştirme programları</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-indigo-600 rounded-lg flex items-center justify-center">
                  <i className="ri-user-star-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Uzman Eğitmenler</h3>
                  <p className="text-gray-600">MYK standartlarında eğitim veren sertifikalı ve deneyimli eğitmen kadrosu</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-indigo-600 rounded-lg flex items-center justify-center">
                  <i className="ri-briefcase-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Kariyer Desteği</h3>
                  <p className="text-gray-600">Mesleki sertifikalar ile iş bulma ve kariyer geliştirme desteği</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MYK Eğitim Programları */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">MYK Sertifika Programları</h2>
            <p className="text-lg text-gray-600">ASSA Akademi MYK onaylı meslek standartları eğitimleri</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-user-line text-indigo-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">İş Güvenliği Uzmanı</h3>
              <p className="text-gray-600">MYK onaylı A, B ve C sınıfı İş Güvenliği Uzmanı sertifika programları</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-stethoscope-line text-indigo-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">İşyeri Hekimi</h3>
              <p className="text-gray-600">MYK standartlarında İşyeri Hekimliği sertifika programı</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-nurse-line text-indigo-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">İSG Hemşiresi</h3>
              <p className="text-gray-600">MYK onaylı İş Sağlığı ve Güvenliği Hemşireliği sertifika programı</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-search-line text-indigo-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Risk Değerlendirme Uzmanı</h3>
              <p className="text-gray-600">MYK standartlarında risk değerlendirmesi ve yönetimi uzmanı eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-fire-line text-indigo-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Yangın Güvenliği Uzmanı</h3>
              <p className="text-gray-600">MYK onaylı yangın güvenliği ve önleme uzmanı sertifika programı</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-building-line text-indigo-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">İnşaat Güvenliği Uzmanı</h3>
              <p className="text-gray-600">MYK standartlarında inşaat sektörü özel güvenlik uzmanı eğitimi</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mesleki Eğitim Programları */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Mesleki Eğitim Programları</h2>
            <p className="text-lg text-gray-600">ASSA Akademi sektörel mesleki eğitim programları</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-tools-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Endüstriyel Bakım Teknisyeni</h3>
              <p className="text-gray-600">Makine bakım ve onarım teknisyenliği mesleki eğitim programı</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-settings-3-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Elektrik Teknisyeni</h3>
              <p className="text-gray-600">Elektrik tesisatı ve endüstriyel elektrik teknisyenliği eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-hammer-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Kaynak Teknisyeni</h3>
              <p className="text-gray-600">Çeşitli kaynak teknikleri ve metal işleme mesleki eğitim programı</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-truck-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Forklift Operatörü</h3>
              <p className="text-gray-600">Forklift ve iş makinesi operatörlüğü sertifika programı</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-computer-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Bilgisayar Programcılığı</h3>
              <p className="text-gray-600">Yazılım geliştirme ve bilgisayar programcılığı mesleki eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-customer-service-2-line text-green-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Müşteri Hizmetleri</h3>
              <p className="text-gray-600">Müşteri ilişkileri ve hizmet kalitesi mesleki eğitim programı</p>
            </div>
          </div>
        </div>
      </section>

      {/* Şehirler */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Hizmet Verdiğimiz İller</h2>
            <p className="text-lg text-gray-600">ASSA Akademi Meslek Eğitimi ve MYK Sertifikaları</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-graduation-cap-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Adana</h3>
              <p className="text-gray-600">Adana Meslek Eğitimi ve MYK</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-graduation-cap-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Mersin</h3>
              <p className="text-gray-600">Mersin Meslek Eğitimi ve MYK</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-graduation-cap-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hatay</h3>
              <p className="text-gray-600">Hatay Meslek Eğitimi ve MYK</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-graduation-cap-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Osmaniye</h3>
              <p className="text-gray-600">Osmaniye Meslek Eğitimi ve MYK</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-indigo-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Mesleki Eğitim ve MYK Sertifikası Almak İster misiniz?</h2>
          <p className="text-xl text-indigo-100 mb-8">
            ASSA Akademi ile kariyer hedeflerinize ulaşın
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/iletisim" 
              className="bg-white text-indigo-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Bilgi Al
            </Link>
            <a 
              href="tel:08503462772" 
              className="bg-indigo-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-800 transition-colors whitespace-nowrap"
            >
              Hemen Ara
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
}
